import React from "react"
import {
  Box,
  Flex,
  Text,
} from "@chakra-ui/react"
import SwitchField from "components/ReactHookForm/SwitchField"
import ModalForm from "components/dialogs/ReactHookForm/ModalForm"
import type { DioboxEvent } from "sharedTypes"

type Props = {
  isOpen: boolean
  onClose: () => void
  event: DioboxEvent
  updateEvent: (params: {}) => Promise<void>
}

const KioskGuestDisplayModal = ({
  isOpen,
  onClose,
  event,
  updateEvent,
}: Props) => {
  if (!isOpen) {
    return null
  }

  return (
    <ModalForm
      title="Display Settings"
      size="xl"
      onClose={onClose}
      initialValues={{
        kioskShowEventTitle: event.kioskShowEventTitle,
        kioskShowGuestPhoto: event.kioskShowGuestPhoto,
        kioskShowGuestSeat: event.kioskShowGuestSeat,
      }}
      onSubmit={async (v) => {
        await updateEvent(v)
        onClose()
      }}
      disableSubmitWhenNotDirty
    >
      {({ control }) => (
        <Flex direction="column" gap={8}>
          <Box>
            <SwitchField
              name="kioskShowEventTitle"
              control={control}
              label="Show Event Title"
              fontSize="lg"
              size="lg"
              mb={1}
              dataTestId="kiosk-show-event-title-switch"
            />
            <Text>Display the event name at the top of the screen.</Text>
            <Text>Turn this off to display a larger event logo.</Text>
          </Box>
          <Box>
            <SwitchField
              name="kioskShowGuestPhoto"
              control={control}
              label="Show Guest Photo"
              fontSize="lg"
              size="lg"
              mb={1}
            />
            <Text>
              Display the guest&apos;s profile photo after check-in, when available.
            </Text>
            <Text>
              Note: Guest photos require an internet connection and may take a few moments to load.
            </Text>
          </Box>
          <Box>
            <SwitchField
              name="kioskShowGuestSeat"
              control={control}
              label="Show Seating Information"
              fontSize="lg"
              size="lg"
              mb={1}
            />
            <Text>
              Display the guest&apos;s assigned table, section, row, or seat when available.
            </Text>
          </Box>
        </Flex>
      )}
    </ModalForm>
  )
}

export default KioskGuestDisplayModal
